<div class="screenshot-gallery-container">
  <header class="gallery-header">
    <h1>Screenshot Gallery</h1>
    <p class="subtitle">Lower Environments - Playwright Test Screenshots</p>
    <nav class="gallery-nav">
      <a href="/style-guide" class="gallery-nav-link">Style Guide</a>
      <a href="/modal-gallery" class="gallery-nav-link">Modal Gallery</a>
    </nav>
  </header>

  @if (screenshotsByCategory.isLoading()) {
    <div class="loading-container">
      <mat-spinner diameter="48"></mat-spinner>
      <p>Loading screenshots...</p>
    </div>
  }
  @if (screenshotsByCategory.error()) {
    <div class="error-container">
      <p>Failed to load screenshots. Make sure the manifest.json exists.</p>
    </div>
  }
  @if (screenshotsByCategory.value()) {
    <div class="filter-controls">
      <div class="viewport-filters">
        @for (option of viewportOptions; track option.value) {
          <button
            type="button"
            [id]="'viewport-filter-' + option.value"
            class="viewport-filter-button cursor-pointer"
            [class.viewport-filter-button-selected]="isViewportSelected(option.value)"
            (click)="toggleViewport(option.value)"
          >
            {{ option.label }}
          </button>
        }
      </div>
    </div>

    <div class="screenshot-bubbles">
      @for (screenshot of getNonWizardScreenshots(); track screenshot.filename) {
        <div class="screenshot-bubble cursor-pointer" (click)="openScreenshot(screenshot)">
          <span class="bubble-label">{{ screenshot.name }}</span>
          <mat-card class="screenshot-card">
            <img [src]="screenshot.path" [alt]="screenshot.name" loading="lazy" />
          </mat-card>
        </div>
      }
    </div>

    @if (getJvBrandScreenshots().length > 0) {
      <section class="wizard-section">
        <h2 class="wizard-title">Joint Ventures</h2>
        <div class="screenshot-bubbles">
          @for (screenshot of getJvBrandScreenshots(); track screenshot.filename) {
            <div class="screenshot-bubble cursor-pointer" (click)="openScreenshot(screenshot)">
              <span class="bubble-label">{{ screenshot.name }}</span>
              <mat-card class="screenshot-card">
                <img [src]="screenshot.path" [alt]="screenshot.name" loading="lazy" />
              </mat-card>
            </div>
          }
        </div>
      </section>
    }

    @if (getPurchaseWizardScreenshots().length > 0) {
      <section class="wizard-section">
        <h2 class="wizard-title">Purchase Wizard</h2>
        <div class="screenshot-bubbles">
          @for (screenshot of getPurchaseWizardScreenshots(); track screenshot.filename) {
            <div class="screenshot-bubble cursor-pointer" (click)="openScreenshot(screenshot)">
              <span class="bubble-label">
                {{ screenshot.stepOrder ? 'Step ' + screenshot.stepOrder + ': ' + screenshot.name : screenshot.name }}
              </span>
              <mat-card class="screenshot-card">
                <img [src]="screenshot.path" [alt]="screenshot.name" loading="lazy" />
              </mat-card>
            </div>
          }
        </div>
      </section>
    }

    @if (getRefinanceWizardScreenshots().length > 0) {
      <section class="wizard-section">
        <h2 class="wizard-title">Refinance Wizard</h2>
        <div class="screenshot-bubbles">
          @for (screenshot of getRefinanceWizardScreenshots(); track screenshot.filename) {
            <div class="screenshot-bubble cursor-pointer" (click)="openScreenshot(screenshot)">
              <span class="bubble-label">
                {{ screenshot.stepOrder ? 'Step ' + screenshot.stepOrder + ': ' + screenshot.name : screenshot.name }}
              </span>
              <mat-card class="screenshot-card">
                <img [src]="screenshot.path" [alt]="screenshot.name" loading="lazy" />
              </mat-card>
            </div>
          }
        </div>
      </section>
    }
  }
  @if (expandedScreenshot()) {
    <div class="screenshot-overlay" (click)="closeScreenshot()">
      <button
        mat-icon-button
        class="nav-button nav-prev cursor-pointer"
        (click)="navigatePrevious(); $event.stopPropagation()"
        [disabled]="!canNavigatePrevious()"
        aria-label="Previous screenshot"
      >
        <mat-icon>chevron_left</mat-icon>
      </button>
      <div class="overlay-content" (click)="$event.stopPropagation()">
        <button mat-icon-button class="close-button cursor-pointer" (click)="closeScreenshot()" aria-label="Close">
          <mat-icon>close</mat-icon>
        </button>
        <img [src]="expandedScreenshot()!.path" [alt]="expandedScreenshot()!.name" />
        <div class="overlay-info">
          <h2>
            {{
              expandedScreenshot()!.stepOrder
                ? 'Step ' + expandedScreenshot()!.stepOrder + ': ' + expandedScreenshot()!.name
                : expandedScreenshot()!.name
            }}
          </h2>
          <p class="route">{{ expandedScreenshot()!.route }}</p>
          <div class="overlay-meta">
            <span class="nav-hint">Use arrow keys to navigate • ESC to close</span>
          </div>
        </div>
      </div>
      <button
        mat-icon-button
        class="nav-button nav-next cursor-pointer"
        (click)="navigateNext(); $event.stopPropagation()"
        [disabled]="!canNavigateNext()"
        aria-label="Next screenshot"
      >
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
  }
</div>
